enum PlatformClientUserFilterType {
    CLIENT_PLANS = 'CLIENT_PLANS',
    CLIENT_VERIFIED = 'CLIENT_VERIFIED',
    CLIENT_ARCHIVED = 'CLIENT_ARCHIVED',
}

export default PlatformClientUserFilterType;
